module.exports = __webpack_public_path__ + "assets/images/fountain-02.d59421deff1dbed22d893e84754718cd.svg";